<template>
    <div class="col-12">
        <el-card class="d-flex justify-content-center align-items-center text-center" style="background-color: #F8F9FA !important;box-shadow: none; border: none;">
            <div>
                <div style="padding: 14px;">
                    <h5 class="text-bat text-secondary "><strong>{{ title }}</strong></h5>
                    <div>
                        <span class="text-bat text-secondary ">{{ description }}</span>
                    </div>
                </div>
                <img src="/img-version2/icons/staff/no-data-staff.png" class="image mt-3" alt="image-no-data-victoria" style="max-width: 100%; height: auto;">
            </div>
        </el-card>
    </div>
</template>

<style scoped>

</style>
<script>

export default {
    props: {
        title: {
            default: null,
        },
        description: {
            default: null,
        },
    },
};
</script>
